import { render, staticRenderFns } from "./CreateChat.vue?vue&type=template&id=a4e8bde0"
import script from "./CreateChat.vue?vue&type=script&lang=js"
export * from "./CreateChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports